export const PHONE_CODES = [
  { l: "FR", c: "+33" },
  { l: "BE", c: "+32" },
  { l: "CH", c: "+41" },
  { l: "LU", c: "+352" },
  { l: "DE", c: "+49" },
  { l: "ES", c: "+34" },
  { l: "IT", c: "+39" },
  { l: "GB", c: "+44" },
  { l: "NL", c: "+31" },
  { l: "PT", c: "+351" },
];
